import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import API_BASE_URL from './config';
import { FaArrowLeft } from 'react-icons/fa';

const StaffDashboard = () => {
  const navigate = useNavigate();
  const [staffData, setStaffData] = useState([]);
  const [summary, setSummary] = useState(null);


  useEffect(() => {
    fetch(`${API_BASE_URL}/api/staff/dashboard-summary`)
      .then(res => res.json())
      .then(data => setSummary(data))
      .catch(err => console.error('Error fetching staff summary:', err));

    fetch(`${API_BASE_URL}/api/staff/pending-deals`)
      .then(res => res.json())
      .then(data => setStaffData(data))
      .catch(err => console.error('Error fetching pending deals:', err));
  }, []);

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <button className="back-btn" onClick={() => navigate('/staff-login')}>
          <FaArrowLeft />
        </button>
        <h1>Welcome Staff</h1>
      </header>

      {summary && (
        <div className="staff-summary-grid">
          <div className="summary-row">
            <div className="summary-box">
              <h4>Total Sales (This Month)</h4>
              <p>₹{summary.monthSales}</p>
            </div>
            <div className="summary-box">
              <h4>Total Profit (This Month)</h4>
              <p>₹{summary.monthProfit}</p>
            </div>
            <div className="summary-box">
              <h4>Total Rewards (This Month)</h4>
              <p>₹{summary.monthRewards}</p>
            </div>
            <div className="summary-box">
              <h4>Total Deals (This Month)</h4>
              <p>{summary.monthDeals}</p>
            </div>
          </div>
          <div className="summary-row">
            <div className="summary-box">
              <h4>Total Sales (All Time)</h4>
              <p>₹{summary.totalSales}</p>
            </div>
            <div className="summary-box">
              <h4>Total Profit (All Time)</h4>
              <p>₹{summary.totalProfit}</p>
            </div>
            <div className="summary-box">
              <h4>Total Rewards (All Time)</h4>
              <p>₹{summary.totalRewards}</p>
            </div>
            <div className="summary-box">
              <h4>Total Deals (All Time)</h4>
              <p>{summary.totalDeals}</p>
            </div>
          </div>
        </div>
      )}

      <section className="deals-list">
        <h2>Staff Dashboard</h2>
        <p>This is the staff dashboard. Functional content will be added soon.</p>

        {staffData.length > 0 ? (
          <div className="pending-deals">
            {staffData.map((deal) => (
              <div className="deal-card" key={deal._id}>
                <img src={`/uploads/${deal.image || 'placeholder.jpg'}`} alt={deal.title} />
                <div className="deal-info">
                  <h3>{deal.title}</h3>
                  <p><strong>Merchant:</strong> {deal.merchantName}</p>
                  <p><strong>Category:</strong> {deal.category}</p>
                  <p><strong>Discount:</strong> {deal.discountValue}%</p>
                  <p><strong>MRP:</strong> ₹{deal.mrp} → ₹{deal.customerBuyPrice}</p>
                  <p>{deal.description}</p>
                  <p><strong>Valid:</strong> {deal.startDate} to {deal.endDate}</p>
                  <button
                    className="approve-btn"
                    onClick={async () => {
                      const res = await fetch(`${API_BASE_URL}/api/staff/approve-deal/${deal._id}`, {
                        method: 'POST',
                      });
                      if (res.ok) {
                        alert('Deal approved!');
                        setStaffData(prev => prev.filter(d => d._id !== deal._id)); // remove approved
                      } else {
                        const result = await res.json();
                        alert(result.error || 'Failed to approve deal');
                      }
                    }}
                  >
                    Approve
                  </button>
                  <button
                    className="reject-btn"
                    onClick={async () => {
                      const confirmed = window.confirm("Are you sure you want to reject this deal?");
                      if (!confirmed) return;

                      const res = await fetch(`${API_BASE_URL}/api/deals/${deal._id}`, {
                        method: 'DELETE',
                      });

                      if (res.ok) {
                        alert('Deal rejected and removed.');
                        setStaffData(prev => prev.filter(d => d._id !== deal._id));
                      } else {
                        const result = await res.json();
                        alert(result.error || 'Failed to reject deal');
                      }
                    }}
                  >
                    Reject
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ color: '#888' }}>No deals pending approval.</p>
        )}
      </section>
    </div>
  );
};

export default StaffDashboard;
